
import { createTranslations } from '../../../i18n/types';

export default createTranslations({
  en: {
    userAgreement: 'User Agreement',
    privacyPolicy: 'Privacy Policy',
    refundPolicy: 'Refund Policy',
    paymentOrder: 'Payment Procedure',
    howItWorks: 'How the service works',
    contacts: 'Contacts',
    support: 'Support',
    refundTerms: 'Refund terms',
    digitalContent: 'Digital content',
    wiki: 'CS2 skin wiki',
    freeSkin: 'Free CS2 skin',
  },
  ru: {
    userAgreement: 'Пользовательское соглашение',
    privacyPolicy: 'Политика конфиденциальности',
    refundPolicy: 'Политика возвратов',
    paymentOrder: 'Порядок оплаты',
    howItWorks: 'Как работает сервис',
    contacts: 'Контакты',
    support: 'Поддержка',
    refundTerms: 'Условия возврата',
    digitalContent: 'Получение цифрового контента',
    wiki: 'Вики скинов CS2',
    freeSkin: 'Бесплатный скин CS2',
  },
  uz: {
    userAgreement: 'Foydalanuvchi shartnomasi',
    privacyPolicy: 'Maxfiylik siyosati',
    refundPolicy: 'Qaytarish siyosati',
    paymentOrder: 'Toʻlov tartibi',
    howItWorks: 'Xizmat qanday ishlaydi',
    contacts: 'Kontaktlar',
    support: 'Qoʻllab-quvvatlash',
    refundTerms: 'Qaytarish shartlari',
    digitalContent: 'Raqamli kontent olish',
    wiki: 'CS2 skinlari vikisi',
    freeSkin: 'CS2 uchun bepul skin',
  },
  fa: {
    userAgreement: 'شرایط استفاده',
    privacyPolicy: 'سیاست حریم خصوصی',
    refundPolicy: 'سیاست بازگشت وجه',
    paymentOrder: 'روال پرداخت',
    howItWorks: 'سرویس چطور کار می‌کند',
    contacts: 'تماس',
    support: 'پشتیبانی',
    refundTerms: 'شرایط بازگشت وجه',
    digitalContent: 'محتوای دیجیتال',
    wiki: 'ویکی اسکین‌های CS2',
    freeSkin: 'اسکین رایگان CS2',
  },
  pt: {
    userAgreement: 'Termos de uso',
    privacyPolicy: 'Política de privacidade',
    refundPolicy: 'Política de reembolso',
    paymentOrder: 'Procedimento de pagamento',
    howItWorks: 'Como o serviço funciona',
    contacts: 'Contatos',
    support: 'Suporte',
    refundTerms: 'Condições de reembolso',
    digitalContent: 'Entrega de conteúdo digital',
    wiki: 'Wiki de skins do CS2',
    freeSkin: 'Skin de CS2 grátis',
  },
  tr: {
    userAgreement: 'Kullanıcı sözleşmesi',
    privacyPolicy: 'Gizlilik politikası',
    refundPolicy: 'İade politikası',
    paymentOrder: 'Ödeme prosedürü',
    howItWorks: 'Hizmet nasıl çalışır',
    contacts: 'İletişim',
    support: 'Destek',
    refundTerms: 'İade koşulları',
    digitalContent: 'Dijital içeriğin teslimi',
    wiki: 'CS2 Skin Vikisi',
    freeSkin: 'Bedava CS2 skin',
  },
  uk: {
    userAgreement: 'Користувацька угода',
    privacyPolicy: 'Політика конфіденційності',
    refundPolicy: 'Політика повернень',
    paymentOrder: 'Порядок оплати',
    howItWorks: 'Як працює сервіс',
    contacts: 'Контакти',
    support: 'Підтримка',
    refundTerms: 'Умови повернення',
    digitalContent: 'Отримання цифрового контенту',
    wiki: 'Вікі скінів CS2',
    freeSkin: 'Безкоштовний скін CS2',
  },
  de: {
    userAgreement: 'Nutzungsvereinbarung',
    privacyPolicy: 'Datenschutzerklärung',
    refundPolicy: 'Rückerstattungsrichtlinie',
    paymentOrder: 'Zahlungsablauf',
    howItWorks: 'So funktioniert der Service',
    contacts: 'Kontakt',
    support: 'Support',
    refundTerms: 'Rückerstattungsbedingungen',
    digitalContent: 'Erhalt digitaler Inhalte',
    wiki: 'CS2-Skin-Wiki',
    freeSkin: 'Gratis-CS2-Skin',
  },
  es: {
    userAgreement: 'Acuerdo de usuario',
    privacyPolicy: 'Política de privacidad',
    refundPolicy: 'Política de reembolsos',
    paymentOrder: 'Procedimiento de pago',
    howItWorks: 'Cómo funciona el servicio',
    contacts: 'Contacto',
    support: 'Soporte',
    refundTerms: 'Condiciones de reembolso',
    digitalContent: 'Recepción de contenido digital',
    wiki: 'Wiki de skins de CS2',
    freeSkin: 'Skin de CS2 gratis',
  },
  pl: {
    userAgreement: 'Umowa użytkownika',
    privacyPolicy: 'Polityka prywatności',
    refundPolicy: 'Polityka zwrotów',
    paymentOrder: 'Tryb płatności',
    howItWorks: 'Jak działa serwis',
    contacts: 'Kontakt',
    support: 'Wsparcie',
    refundTerms: 'Warunki zwrotu',
    digitalContent: 'Otrzymanie treści cyfrowych',
    wiki: 'Wiki skinów CS2',
    freeSkin: 'Darmowy skin CS2',
  },
});
